import { useState } from 'react';
import { CATEGORY_STATUS_TYPE, CATEGORY_TYPE } from '../../../../../constants/service/app/categoryConstants';

export const useTotalCategory = () => {
  // 선택한 전체 1차 카테고리 리스트
  const [selectedTotalMainCategoryList, setSelectedTotalMainCategoryList] = useState([]);
  // 선택한 전체 2차 카테고리 리스트
  const [selectedTotalSubCategoryList, setSelectedTotalSubCategoryList] = useState([]);
  // 선택한 전체 카테고리 리스트 탭 타입(일반형, 강조형)
  const [totalCategoryTabType, setTotalCategoryTabType] = useState(String(CATEGORY_TYPE.GENERAL));
  // 전체 카테고리 리스트
  const [totalCategoryDataSource, setTotalCategoryDataSource] = useState([]);

  // 전체 카테고리 rowSelection 옵션 객체
  const totalCategoryRowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    // 카테고리 상태가 비활성이거나 2차 카테고리일 시, 부모 1차 카테고리의 상태가 비활성이면 2차 카테고리 disabled 처리
    getCheckboxProps: (record) => ({
      disabled:
        record.status === CATEGORY_STATUS_TYPE.INACTIVE || record.parentStatus === CATEGORY_STATUS_TYPE.INACTIVE,
    }),
    onSelect: (record, selected, selectedRows) => {
      console.log('onselect', record, selected, selectedRows);
      // 카테고리가 선택된 경우
      if (selected) {
        // 선택한 카테고리가 1차 카테고리일 때
        if (!record.parentId) {
          // 현재 전시 중인 1차 카테고리일 때 선택한 1차 카테고리 목록에 추가하지 않고 반환함
          // if (record.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT) return;

          setSelectedTotalMainCategoryList((prev) => [...prev, record]);
          setSelectedTotalSubCategoryList((prev) => [
            ...prev,
            ...record.children.filter((sub) => sub.status !== CATEGORY_STATUS_TYPE.INACTIVE),
          ]);
          return;
        }
        // 선택한 카테고리가 2차 카테고리일 때
        // 현재 전시 중인 2차 카테고리일 때 선택한 2차 카테고리 목록에 추가하지 않고 반환함
        // if (record.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT) return;

        setSelectedTotalSubCategoryList((prev) => [...prev, record]);

        // 이미 1차 전체 카테고리가 선택되어 있는 상태에서 해당 2차 전시 카테고리를 선택하면 선택한 1차 전시 카테고리 배열에 추가하지 않음
        if (
          selectedTotalMainCategoryList.length &&
          selectedTotalMainCategoryList.find((category) => category.id === record.parentId)
        )
          return;

        setSelectedTotalMainCategoryList((prev) => [
          ...prev,
          totalCategoryDataSource.find((category) => category.id === record.parentId),
        ]);

        return;
      }

      // 카테고리 선택이 해제된 경우
      // 선택 해제된 카테고리가 1차 카테고리일 때
      if (!record.parentId) {
        // 현재 전시 중인 1차 카테고리일 때 필터링 하지 않고 반환함
        // if (record.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT) return;

        setSelectedTotalMainCategoryList((prev) => prev.filter((category) => category.id !== record.id));
        // 하위 2차 카테고리도 모두 선택 해제 처리
        setSelectedTotalSubCategoryList((prev) => prev.filter((category) => category.parentId !== record.id));
        return;
      }
      // 선택 해제된 카테고리가 2차 카테고리일 때
      // 현재 전시 중인 2차 카테고리일 때 필터링 하지 않고 반환함
      // if (record.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT) return;
      setSelectedTotalSubCategoryList((prev) => prev.filter((category) => category.id !== record.id));
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log('onselectAll', selected, selectedRows, changeRows);
      // 카테고리가 전체 선택된 경우
      if (selected) {
        selectedRows.forEach((category) => {
          // 1차 카테고리일 때
          if (!category.parentId) {
            // 현재 전시 중인 1차 카테고리일 때 필터링 하지 않고 반환함
            // if (category.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT) return;
            setSelectedTotalMainCategoryList((prev) => [
              ...prev,
              {
                ...category,
                // 전체 선택시 children이 포함되있지 않은 상태를 가져오므로 임의로 넣어줌
                children: totalCategoryDataSource.find((totalCategory) => totalCategory.id === category.id)
                  ? totalCategoryDataSource.find((totalCategory) => totalCategory.id === category.id).children
                  : [],
              },
            ]);
            return;
          }

          // 2차 카테고리일 때
          // 현재 전시 중인 2차 카테고리일 때 필터링 하지 않고 반환함
          // if (category.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT) return;
          setSelectedTotalSubCategoryList((prev) => [...prev, category]);
        });
        return;
      }
      // 카테고리가 전체 선택 해제된 경우 선택된 1차, 2차 카테고리 배열 상태 빈 배열로 초기화
      setSelectedTotalMainCategoryList([]);
      setSelectedTotalSubCategoryList([]);
    },
    selectedRowKeys: [
      ...selectedTotalMainCategoryList.map((category) => category.id),
      ...selectedTotalSubCategoryList.map((category) => category.id),
    ],
  };

  return {
    totalCategoryDataSource,
    totalCategoryTabType,
    setTotalCategoryTabType,
    totalCategoryRowSelection,
    setTotalCategoryDataSource,
    selectedTotalMainCategoryList,
    selectedTotalSubCategoryList,
    setSelectedTotalMainCategoryList,
    setSelectedTotalSubCategoryList,
  };
};
